var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailsSubmittedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.416,
    height: 64.416,
    rx: 32.208,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1523 41.7495V42.6165C22.1523 43.0941 22.539 43.4815 23.0165 43.4815H32.6327",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7891 21.3789H38.7132C39.1907 21.3789 39.5782 21.7664 39.5782 22.2439V33.3303",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8398 19.6494H36.927C37.4046 19.6494 37.792 20.0369 37.792 20.5144V35.2332",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6336 41.7494H21.2283C20.7508 41.7494 20.3633 41.3619 20.3633 40.8844V24.21",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7833 46.6494H34.8986C33.6474 46.6494 32.6328 45.6349 32.6328 44.3837V37.4992C32.6328 36.2479 33.6474 35.2334 34.8986 35.2334H41.7833C43.0345 35.2334 44.0491 36.2479 44.0491 37.4992V44.3837C44.0491 45.6349 43.0345 46.6494 41.7833 46.6494Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3633 24.2111L24.9328 19.6494V23.3461C24.9328 23.8236 24.5457 24.2107 24.0682 24.2107H20.3633V24.2111Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6615 23.8353H27.8356C27.3438 23.8353 26.9453 23.4368 26.9453 22.945V22.943C26.9453 22.4512 27.3438 22.0527 27.8356 22.0527H31.6615C32.1533 22.0527 32.5518 22.4512 32.5518 22.943V22.945C32.5518 23.4368 32.1533 23.8353 31.6615 23.8353Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4414 27.2866H34.7322",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4414 29.7036H34.7322",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6211 32.1191H34.7296",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4414 32.1191H30.7111",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4414 34.5317H28.3646",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4414 36.9492H28.3646",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1378 39.2769L37.813 42.6016L36.2305 41.0191",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsSubmittedIcon);
export default __webpack_public_path__ + "static/media/DetailsSubmittedIcon.351bb4acca091cb89173db4b27ae0d4d.svg";
export { ForwardRef as ReactComponent };